




















import { apiBlindBoxBoxPrizeRecords } from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '开盒记录',
        }))
      }

      loading = computed(() => false)

      query = useQuery<{
        id: string
      }>()

      handleLoad = async ({ pageNumber }: any) => {
        return apiBlindBoxBoxPrizeRecords({
          id: this.query.id,
          pageIndex: pageNumber,
          pageSize: 10,
        })
      }
    },
)
